import React from 'react'
import { useTranslation } from 'react-i18next'
import { PageHeader } from 'components/header/PageHeader'
import { useMappedRoles } from 'hooks/useMappedRoles'
import ApiKeyHeaderCreateButton from './ApiKeyHeaderCreateButton'

interface ApiKeyHeaderProps {
  onSheetOpen: () => void
}

const ApiKeyHeader = ({ onSheetOpen }: ApiKeyHeaderProps) => {
  const { t } = useTranslation()
  const permissions = useMappedRoles().manageApiIntegration
  const canEdit = permissions?.canEdit

  return (
    <PageHeader
      description={t('manageApiKeys.apiKeysDescription')}
      renderRightSection={canEdit && <ApiKeyHeaderCreateButton onSheetOpen={onSheetOpen} />}
    />
  )
}

export default React.memo(ApiKeyHeader)
